import { Space } from 'antd';
import { Link } from 'react-router-dom';

import { puser } from '@/proto/proto';
import { PATH_MAIN } from '@/constants/constant';
import logoImg from '@images/common/logo-bizcenter-main.png';
import alarmIcon from '@images/icon/icon_alarm.png';
import profileIcon from '@images/icon/icon_my.png';
import { PageHeaderProps as AntHeaderProps } from 'antd/lib/page-header';
import { Button, LayoutHeader } from '@/components/atoms';

export type HeaderProps = {
  user: puser.IPbUser;
  count: number;
  logout: () => void;
};

const Header = ({ user, count, logout }: HeaderProps & AntHeaderProps) => {
  return (
    <LayoutHeader className="header">
      <Space className="float-left h-full">
        <div className="logo">
          <Link to={PATH_MAIN} className="font-bold">
            <img src={logoImg} alt="로고" />
          </Link>
        </div>
      </Space>
      <Space className="float-right h-full">
        <Button type="text">
          <Space direction="horizontal">
            <img src={alarmIcon} alt="알림 아이콘" />
            알림
          </Space>
        </Button>
        <Button type="text" onClick={logout}>
          <Space direction="horizontal">
            <img src={profileIcon} alt="사용자 아이콘" />
            {user.name}
          </Space>
        </Button>
      </Space>
    </LayoutHeader>
  );
};

Header.defaultProps = {
  title: '',
};

export default Header;
